module.exports = __webpack_public_path__ + "img/fourday_ps_18.f74ef1d7.jpg";